import { allTrackers } from "app/services/track/track";
import createOpportunityListsTrackingService from "./factory";

export default createOpportunityListsTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));
